import { render } from "./ExternalDashboard.vue?vue&type=template&id=407a417e"
import script from "./ExternalDashboard.vue?vue&type=script&lang=js"
export * from "./ExternalDashboard.vue?vue&type=script&lang=js"

import "./ExternalDashboard.styles.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__